import { Controller } from "@hotwired/stimulus"
import { RecorderApp } from "../recorder/app"

export default class extends Controller {
  static values = { csrf: String, email: String }

  connect() {
    this.app = new RecorderApp(this.element, { csrf: this.csrfValue, email: this.emailValue })
    this.app.start()
  }

  disconnect() {
    this.app?.destroy()
  }

  record() {
    this.app.record()
  }

  togglePreview() {
    this.app.togglePreview()
  }
}
